import React from "react";
import { Quote, MapPin, Instagram } from "lucide-react";
import { PROFILE } from "@/lib/portfolioData";
import SectionHeader from "@/components/SectionHeader";
import Reveal from "@/components/Reveal";

export default function About() {
  return (
    <section id="about" className="relative py-24 md:py-36 px-6 md:px-10" data-testid="about-section">
      <div className="max-w-[1400px] mx-auto">
        <SectionHeader
          number="01"
          tag="About Me"
          title={<>
            The <span className="text-gradient-gold">Story</span>
            <br />
            Behind the Lens
          </>}
        />

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          {/* Portrait */}
          <Reveal className="lg:col-span-5">
            <div className="arched relative aspect-[4/5] max-w-[440px]">
              <img
                src="https://i.postimg.cc/RM0S6JKV/Full-Size-Render.jpg"
                alt={PROFILE.name}
                className="w-full h-full object-cover"
                loading="lazy"
              />
              <div className="absolute inset-0 pointer-events-none bg-gradient-to-t from-black/60 via-transparent to-transparent" />
              <div className="absolute bottom-6 left-6 right-6 flex items-center justify-between">
                <div>
                  <p className="text-[10px] uppercase tracking-[0.3em] text-[#D4AF37] font-display mb-1">
                    Est. 2023
                  </p>
                  <p className="font-display text-lg text-white">{PROFILE.name}</p>
                </div>
                <a
                  href={PROFILE.instagramUrl}
                  target="_blank"
                  rel="noreferrer"
                  className="w-10 h-10 rounded-full glass flex items-center justify-center text-white hover:text-[#D4AF37]"
                  data-testid="about-instagram"
                  aria-label="Instagram"
                >
                  <Instagram className="w-4 h-4" />
                </a>
              </div>
            </div>

            <div className="mt-6 flex items-center gap-2 text-sm text-[#B3B3B3]">
              <MapPin className="w-4 h-4 text-[#D4AF37]" />
              {PROFILE.location}
            </div>
          </Reveal>

          {/* Text */}
          <Reveal className="lg:col-span-7" delay={150}>
            <p className="font-serif-display italic text-2xl md:text-3xl leading-[1.35] text-white mb-8">
              "I believe every destination, every culture, and every moment deserves
              to be experienced through <span className="text-[#D4AF37]">meaningful storytelling</span>."
            </p>

            <div className="space-y-5 text-[#B3B3B3] text-base md:text-lg leading-relaxed">
              <p>{PROFILE.bio}</p>
              <p>{PROFILE.bioLong}</p>
              <p className="text-white/85">
                Every project is approached with creativity, precision, authenticity,
                and meticulous attention to detail.
              </p>
            </div>

            {/* Mission card */}
            <div className="mt-10 glass rounded-2xl p-8 relative overflow-hidden">
              <Quote className="absolute -top-4 -left-2 w-24 h-24 text-[#D4AF37]/10" />
              <p className="relative text-white/90 font-serif-display italic text-lg md:text-xl leading-relaxed">
                {PROFILE.mission}
              </p>
              <div className="mt-6 flex items-center gap-3">
                <div className="w-8 h-[1px] bg-[#D4AF37]" />
                <span className="text-[10px] uppercase tracking-[0.35em] text-[#D4AF37] font-display">
                  Mission Statement
                </span>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
